const NOTE_PREVIEW_MAX_CHARS = 220
const NOTE_PREVIEW_MAX_LINES = 4

export const isNotePreviewLong = (content: string): boolean => {
  const text = content.trim()
  if (!text) return false
  if (text.length > NOTE_PREVIEW_MAX_CHARS) return true
  return text.split(/\n/).length > NOTE_PREVIEW_MAX_LINES
}
